<template>
  <section>
    <div class="box">
      <div class="box-content">
        <!-- form -->
        <validation-observer ref="form" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(createAutomation)">
            <div class="margin-top-l">
              <validation-provider
                name="nome"
                rules="required"
                v-slot="{ errors }"
              >
                <div
                  class="form-field item group-input "
                  :class="{ errors: errors[0] }"
                >
                  Nome da Automação
                  <input
                    type="text"
                    v-model="newAutomation.name"
                    placeholder="Nome da automação"
                  />
                  <span class="erros-alert">{{ errors[0] }}</span>
                </div>
              </validation-provider>
              <!-- type -->
              <div class="flex column">
                <div class="flex-1 p-8">
                  Tipo de Automação
                </div>
                <div class="flex-1" style="padding: 8px">
                  <div
                    class="button secondary"
                    @click="newAutomation.auto_type = 'EMAIL'"
                    :class="{ active: newAutomation.auto_type === 'EMAIL' }"
                  >
                    E-MAIL
                  </div>
                  <div
                    class="button secondary"
                    @click="newAutomation.auto_type = 'WHATSAPP'"
                    :class="{ active: newAutomation.auto_type === 'WHATSAPP' }"
                    style="margin-left: 8px"
                  >
                    WHATSAPP
                  </div>
                  <div
                    class="button secondary"
                    @click="newAutomation.auto_type = 'SMS'"
                    :class="{ active: newAutomation.auto_type === 'SMS' }"
                    style="margin-left: 8px"
                  >
                    SMS
                  </div>
                </div>
              </div>

              <!-- contacts -->
              <div>
                <div class="flex p-8 margin-top-m column">
                  Gatilho de ativação:
                  <div class="margin-top-s">
                    <p>
                      Quando o contato entrar em uma lista ou for adicionado uma tag a automação vai começar para ele.
                    </p>
                  </div>
                </div>
                <div class="flex margin-top-l">
                  <div class="flex-1">
                    <div class="form-field item group-input ">
                      Lista
                      <select class="input" v-model="newAutomation.contact_list_id">
                        <option value=""> - </option>
                        <option
                          v-for="(v, k) in listsAccount"
                          :key="k"
                          :value="v.id"
                        >
                          {{ v.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="flex-1">
                    <div class="form-field item group-input ">
                      Tag
                      <select class="input" v-model="newAutomation.contact_tag_id">
                        <option value=""> - </option>
                        <option
                          v-for="(v, k) in tagsAccount"
                          :key="k"
                          :value="v.id"
                        >
                          {{ v.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="flex-1">
                    <div class="form-field item group-input ">
                      Exclusão de Tag
                      <select class="input" v-model="newAutomation.not_contact_tag_id">
                        <option value=""> - </option>
                        <option
                          v-for="(v, k) in tagsAccount"
                          :key="k"
                          :value="v.id"
                        >
                          {{ v.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="flex margin-top-l">
                  <div class="flex-1">
                    <div class="form-field item group-input ">
                      Tempo em minutos que o contato foi inserido na <b>Lista</b> Ou <b>Tag</b> para ativar a automação.
                      <input type="number" v-model="newAutomation.time_to_active"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="margin-top-l actions">
              <router-link :to="{ name: 'Automation' }">
                <button class="button secondary">
                  Voltar
                </button>
              </router-link>

              <button class="button primary" type="submit">
                Criar Automação
              </button>
            </div>
          </form>
        </validation-observer>
      </div>
    </div>
  </section>
</template>

<script>

import {
  createAutomation,
  getAutomation,
} from "@/services/automation";

import {
  getTags
} from "@/services/tag";

import {
  getLists
} from "@/services/list";

export default {
  name: "automation-new",
  components: {},
  props: ['automation_id'],
  data() {
    return {
      newAutomation: {
        name: "",
        auto_type: "EMAIL",
        status: "DRAFT",
        contact_list_id: null,
        contact_tag_id: null,
        not_contact_tag_id: null,
        time_to_active: 60,
      },
      listsAccount: [],
      tagsAccount: [],
    };
  },
  mounted() {
    this.getTags()
    this.getLists()

    if (this.automation_id) {
      this.getAutomation()
    }

  },
  watch: {
    
  },
  computed: {
  },
  methods: {
    getAutomation() {
      getAutomation(this.automation_id)
        .then(result => {
          this.newAutomation = result
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Falha ao buscar Automação'
          })
        })
    },
    createAutomation() {
      let params = this.newAutomation;
      
      createAutomation(params)
        .then((result) => {
          // TODO: Redirect to details
          this.$toast.success({
            title: "Sucesso",
            message: "Automação criada com sucesso",
          });

          this.$router.push({ name: 'AutomationEdit', params: { automation_id: result.id}})

          })
          .catch(() => {
            this.$toast.error({
              title: "Erro",
              message: "Ocorreu algum problema",
            });
          });
    },
    getTags() {
      this.getTags = []
      getTags()
        .then((result) => {
          this.tagsAccount = result.map(r => { return { id: r.id, label: r.name } })
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Falha ao buscar dados'
          })
        })
    },
    getLists() {
      getLists()
        .then((result) => {
          this.listsAccount = result.map(r => { return { id: r.id, label: r.name } })
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Falha ao buscar dados'
          })
        })
    },
  },
};
</script>

<style lang="scss" scoped>
.contacts {
  padding-left: 8px;
}
.p-8 {
  padding: 0px 8px;
}

textarea {
  border-radius: 5px;
  border: 1px solid #3333;
  padding: 15px;
  max-width: 1030px;
  min-width: 1030px;
  min-height: 200px;
  max-height: 200px;
}

.active {
  background: var(--primary) !important;
  color: #fff !important;
}

.actions {
  padding: 0px 8px;
  * {
    margin-right: 8px;
  }
}
</style>

<style lang="scss">
.mx-datepicker {
  .mx-input-wrapper {
    .mx-input {
      height: 50px;
    }
  }
  // fix icon
  svg {
    margin-top: 10px;
  }
}
</style>
